import { ElementaryZone } from "@/models/site.model";
import store from "@/store";
import { computed, reactive, toRef } from "@vue/composition-api";
import useVuelidate, { Validation } from "@vuelidate/core";
import { required, numeric, maxLength, maxValue, minValue } from "@vuelidate/validators";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(props: any) {
    const maxZoneVolume: number = store.state.globalAppDataModule.settings.maxZoneVolume;

    const el = reactive(props);
    const elementaryZone = toRef(el, "elementaryZone");
    const rules = computed(() => ({
      name: {
        maxLength: maxLength(40),
        required,
      },
      volume: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(maxZoneVolume),
        numeric,
      },
    }));

    return { v: useVuelidate(rules, elementaryZone) };
  },
})
export default class ElementaryZoneItemComponent extends Vue {
  @Prop()
  elementaryZone!: ElementaryZone;
  @Prop()
  elementaryZones!: ElementaryZone[];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop() fields!: any[];
  @Prop()
  index!: number;

  v!: Validation;

  // get max zone volume from store
  get maxZoneVolume(): number {
    return store.state.globalAppDataModule.settings.maxZoneVolume;
  }

  /**
   * verify if current field of personnel decontamination has to be disabled
   *  @param value witch represents the value of the field
   *  @param max init to 2, it represents the max amount of true in array
   */

  personnelDecontaminationDisabled(value: boolean, max = 2): boolean {
    return this.elementaryZones.filter((e) => e.personnelDecontamination).length >= max && !value;
    
  }

  // get field label
  fieldLabel(key: string): string {
    const items = this.fields.find((it) => it.key == key);
    return items ? items.label.toString() : "";
  }

  /**
   * verify if current field of waste decontamination has to be disabled
   *  @param value witch represents the value of the field
   *  @param max init to 2, it represents the max amount of true in array
   */

  wasteDecontaminationDisabled(value: boolean, max = 2): boolean {
    return this.elementaryZones.filter((e) => e.wasteDecontamination).length >= max && !value;
  }

  get isPhone(): boolean {
    return !this.$screen.lg;
  }

  // emit an event to delete elementaryZone
  deleteElementaryZone(): void {
    this.$emit("deleteZone");
  }
}
